import theme from "../assets/theme.png";
import config from "../assets/config.png";
import userIcon from "../assets/user.png";
import arrowDown from "../assets/seta.png";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

const Header = () => {
  const { user } = useAuth();

  const location = useLocation();
  const navigate = useNavigate(); // Hook para navegação

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    // Lógica para logout
    const tokenLocalStorge = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    if (user) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      navigate("/login");
    } else {
      const tokenSessionStorage = sessionStorage.getItem("token");
      if (tokenSessionStorage) {
        sessionStorage.removeItem("token");
        navigate("/login");
      }
    }
  };

  // Determinar o nome atual
  const getHeaderTitle = () => {
    const pathname = location.pathname;

    if (pathname.startsWith("/pedidos")) {
      const index = pathname.split("/").pop();
      if (pathname === "/pedidos/novo-pedido") return "Novo Pedido";
      if (pathname.startsWith("/pedidos/detalhes")) {
        return `P00${index}-${new Date().getFullYear()}`;
      }
      return "Pedidos";
    }

    if (pathname.startsWith("/cargas")) {
      if (pathname === "/cargas/nova-carga") return "Nova Carga";
      if (pathname.startsWith("/cargas/detalhes")) return "Detalhes da Carga";
      return "Cargas";
    }

    if (pathname === "/calendario") return "Calendário";
    if (pathname === "/dashboard") return "Início";
    if (pathname.startsWith("/simulacao")) return "Detalhes da Simulação";
    if (pathname === "/simulacoes") return "Simulações";
    if (pathname === "/simulacoes/nova-simulacao") return "Fazer Simulação";
    if (pathname === "/configuracoes") return "Configurações";
    if (pathname === "/previsions") return "Previsões";
    if (pathname === "/pagamentos") return "Pagamentos";
    if (pathname === "/calculadora") return "Calculadora";
    if (pathname === "/produtos") return "Produtos";
    if (pathname.startsWith("/previsions/edit")) return "Editar Previsão";
  };

  const handleNavigate = () => {
    navigate("/configuracoes");
  };

  return (
    <header className="h-[91px] flex justify-between items-center px-6 bg-[#F2F2F2] w-full">
      <h2 className="ml-10 font-bold text-xl capitalize text-boldGray opacity-70">
        {`${getHeaderTitle()}`}
      </h2>
      <div className="flex ">
        <div className="items-center flex mr-10">
          {/* <button className="flex items-center">
            <img src={theme} alt="" />
          </button> */}
          {user && user.accessType === "ADMIN" && (
            <button onClick={handleNavigate}>
              <img src={config} alt="" />
            </button>
          )}
        </div>
        <div className="flex items-center">
          <button>
            <img src={userIcon} alt="" />
          </button>
          {user && <p className="text-base mx-4">{user.name}</p>}
          <button className="ml-4" onClick={toggleDropdown}>
            <img src={arrowDown} alt="" />
          </button>
          {isOpen && (
            <>
              <div className="relative z-20">
                <div className="absolute right-0 mt-2 w-28 bg-white border border-gray-300 rounded-lg shadow-lg z-10">
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                  >
                    Sair
                  </button>
                </div>
              </div>
              <div
                id="modal-bg"
                className="h-screen w-screen z-10 absolute inset-0"
                onClick={() => setIsOpen(false)}
              ></div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
